class MarketOrders {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/market-orders`;

  }

  async getPaginatedMarketOrdersByQueryOptions(paginationOptions) {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, { paginationOptions });

  }

  async getMarketOrderById(marketOrderId, projection) {

    const path = `${this.basePath}/:marketOrderId`;

    return this.apiClient.get(path, { marketOrderId }, { projection });

  }

  async refundMarketOrderById(marketOrderId) {

    const path = `${this.basePath}/:marketOrderId/refund`;

    return this.apiClient.post(path, { marketOrderId }, {}, {});

  }

}

export default MarketOrders;